/**
 * 时间戳转时间
 * **/
export const dateToStr = function (input, format = 'yy/MM/dd hh:mm:ss') {
  if (typeof input !== 'object') {
    input = new Date(input)
  }
  let o = {
    'M+': input.getMonth() + 1, // 月份
    'd+': input.getDate(), // 日
    'h+': input.getHours(), // 小时
    'm+': input.getMinutes(), // 分
    's+': input.getSeconds(), // 秒
    'q+': Math.floor((input.getMonth() + 3) / 3), // 季度
    S: input.getMilliseconds() // 毫秒
  }

  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (input.getFullYear() + '').substr(4 - RegExp.$1.length))
  // 不够2位的前面补0
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}



// WEBPACK FOOTER //
// ./src/filterFunction/data.js